import { BaseModel } from '../../../models/base-model'
import { Test, TestExecutionResult } from '../../models'

export class TestExecution extends BaseModel {
  public userId: string
  public status: string
  public test: Test = new Test()
  public testId: string
  public testExecutionResults: TestExecutionResult[]
  public completedAt: Date
  public createdAt: Date
  public newTakesAllowed: boolean

  public get isCompleted() {
    return this.status === 'finished' || this.status === 'aborted'
  }

  public get isIncomplete() {
    return this.status === 'started' || this.status === 'in_progress' || this.status === 'paused'
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-execution/test-execution.ts